import Styles from './LectureEditor.module.scss';

// module imports
import { useState, useContext, useEffect } from 'react';
import { useParams, useNavigate ,Link} from 'react-router-dom';
import { TextField, MenuItem, Backdrop, DialogTitle, Autocomplete } from '@mui/material';
import FeatherIcon from 'feather-icons-react';
import { Tooltip } from '@mui/material/';
import axios from 'axios';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

// component imports
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import { ConfirmationCard } from 'components/global/ConfirmationCard/ConfirmationCard';
import { QuizForm } from 'components/global/LMS/QuizForm/QuizForm';
import { UserManualForm } from 'components/global/LMS/UserManualForm/UserManualForm';
import { ViewContext, AuthContext, useAPI, Form, Card, Message, useCan } from 'components/lib';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';
import { Dialog } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { ClickAwayListener } from '@mui/base/ClickAwayListener';
import { Transcript } from 'components/global/LMS/Transcript/Transcript';

const LectureTypeJSX = ({ open, alterLectureAction, showAddLecture, selectExistingLecture, handleLecturePost, discardCloseLecture, newLecture, getExistingLectures, existingLecture }) => {
    return (
        <Dialog
            onClose={() => { alterLectureAction({ visibility: false }) }}
            open={open}

        >
            <DialogTitle>
                Add Lecture
            </DialogTitle>
            <div
                id='select_lecture_type'
                className={Styles.selectLectureType}
            >
                {!showAddLecture.lecture_type && <>
                    <AivagamButton
                        buttonText={'Add New Lecture'}
                        onClick={() => { alterLectureAction({ visibility: false, action: 'add', lectureType: 'new_lecture' }) }}
                    />
                    <AivagamButton
                        buttonText={'Add Existing Lecture'}
                        onClick={() => { getExistingLectures() }}
                    />
                </>}
                {
                    (showAddLecture.action === 'add' && showAddLecture.lecture_type === 'existing_lecture') &&
                    <div className={Styles.lectureSelectContainer}>
                        <p >
                            Lecture Name
                        </p>
                        <Autocomplete
                            fullWidth
                            // value={newLecture.name || null}
                            id="module_select"
                            options={existingLecture?.length ? existingLecture : []}
                            onChange={selectExistingLecture}
                            getOptionSelected={(option, value) => (option.title === value.title)}
                            getOptionLabel={(option) => (option ? option?.title : '')}
                            renderInput={(params) => <TextField {...params} label="Select Lecture" />}

                        />

                        <span className={Styles.addLectureBtnContainer}>
                            <AivagamButton
                                buttonText={"Cancel"}
                                onClick={discardCloseLecture}
                                icon
                                type="cancel"
                            />
                            <AivagamButton
                                buttonText={"Add Lecture"}
                                disabled={!newLecture?.id?.length}
                                onClick={handleLecturePost}
                                icon
                                type="confirm"
                            />
                        </span>
                    </div>
                }
            </div>
        </Dialog>
    )
}

export function LectureEditor(props) {


    const { moduleId, courseID } = useParams();
    const { data, loading } = useAPI(`/api/lms/modules/lectures?id=${moduleId}`);

    const [lecturesList, setLecturesList] = useState()
    const [quizLoading, setQuizLoading] = useState(false);
    const [existingLecture, setExistingLecture] = useState([]);
    const [showOptions, setShowOptions] = useState(false)
    const permission = useCan('lms.lecture.view')

    useEffect(() => {
        if (data?.lectures) {
            setLecturesList(data.lectures)
        }
    }, [data])

    const [showAddLecture, setShowAddLecture] = useState({
        show: false,
        index: -1,
        action: "",
        lectureID: -1
    })
    const [confirmSubmit, setConfirmSubmit] = useState(false);
    const [newLecture, setNewLecture] = useState();

    const authContext = useContext(AuthContext)
    const viewContext = useContext(ViewContext)

    const GetIcon = ({ type }) => {
        switch (type) {
            case 'video':
            case 'video_ai_transcript':
                return <FeatherIcon color='black' icon='play-circle' />;
            case 'youtube_url':
                return <FeatherIcon color='black' icon='youtube' />;
            case 'document':
                return <FeatherIcon color='black' icon='file-text' />;
            case 'quiz':
                return <FeatherIcon color='black' icon='help-circle' />;
            case 'ai_quiz':
                return <FeatherIcon color='darkgreen' icon='cpu' />;
            default:
                return <FeatherIcon color='black' icon='hexagon' />;
        }
    };


    const alterLectureAction = ({ action, visibility = true, editIndex, lectureID, lectureType }) => {
        if (action !== 'delete') {
            setShowAddLecture(prevState => ({
                ...prevState,
                action: action,
                show: visibility,
                index: action === "edit" ? editIndex : -1,
                lectureID: action === "edit" ? lectureID : -1,
                lecture_type: lectureType
            }));
            return;
        }

        if (action === 'delete') {
            setShowAddLecture(prevState => ({
                ...prevState,
                action: action,
                show: false,
                index: editIndex,
                lectureID: lectureID
            }));

            setShowOptions(lecturesList?.[editIndex]?.creator_id === authContext.user.creator_id || permission) 
            setConfirmSubmit(true)
        }
    }

    const selectExistingLecture = (e, values) => {
        handleLectureChange('id', values?.id);
        handleLectureChange('name', values?.title);
    }

    const handleLectureChange = (name, value) => {
        setNewLecture(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleLectureDelete = ({ isAssociation = false }) => {
        let endpoint
        if (isAssociation) {
            endpoint = `/api/lms/modules/${moduleId}/lectures/${showAddLecture.lectureID}`;
        } else {
            endpoint = `/api/lms/lectures/${showAddLecture.lectureID}`;
        }

        const options = {
            method: "DELETE",
            url: endpoint,
            headers: {
                "accept": "application/json",
            },
            data: {
                courseID: courseID
            }
        };
        axios
            .request(options)
            .then(function (response) {
                if (response.status === 200) {
                    const updatedModulesList = lecturesList.filter((_, index) => index !== showAddLecture.index);
                    setLecturesList(updatedModulesList);
                    viewContext.notification.show(response.data.message, 'success');
                }
            })
            .catch((err) => {
                let status = err.response.status;
                if (status === 401) {
                    authContext.signout()
                }
                viewContext.notification.show(err.response.data.message, 'error');
            });
        discardCloseLecture()
    }

    const discardCloseLecture = () => {
        setNewLecture({})
        alterLectureAction({
            action: "",
            visibility: false,
            editIndex: -1
        })
    }


    const syncLectureEdit = (lectureIndex) => {
        setNewLecture({
            id: lecturesList[lectureIndex].id || "",
            name: lecturesList[lectureIndex].name || "",
            description: lecturesList[lectureIndex].description || "",
            source: lecturesList[lectureIndex].source || "",
            type: lecturesList[lectureIndex].type || "",
            lockSelect: !!lecturesList[lectureIndex].source
        })
    }

    const handleLectureUpdate = (index) => {
        const updatedLecturesList = [...lecturesList];
        updatedLecturesList[index].name = newLecture.name
        updatedLecturesList[index].description = newLecture.description
        updatedLecturesList[index].type = newLecture.type

        const options = {
            method: "PATCH",
            url: `/api/lms/lectures/${newLecture.id}`,
            headers: {
                "accept": "application/json",
            },
            data: {
                title: newLecture.name,
                description: newLecture.description,
                type: newLecture.type,
                courseID: courseID
            },
        };
        axios
            .request(options)
            .then(function (response) {
                setLecturesList(updatedLecturesList);
                viewContext.notification.show(response.data.message, 'success');
            })
            .catch((err) => {
                let status = err.response.status;
                if (status === 401) {
                    authContext.signout()
                }
                viewContext.notification.show(err.response.data.message, 'error');
            });

        discardCloseLecture()
    }

    const handleLecturePost = () => {
        // source is not included in the new lecture field till content is added
        // which is only done POST metadata
        const addingLecture = { ...newLecture, source: "" }

        const options = {
            method: "POST",
            url: "/api/lms/lectures",
            headers: {
                "accept": "application/json",
            },
            data: {
                lecture_id: addingLecture?.id || null,
                title: addingLecture.name,
                type: addingLecture.type,
                description: addingLecture.description,
                moduleID: moduleId,
                orderID: lecturesList.length + 1,
                courseID: courseID

            },
        };
        axios
            .request(options)
            .then(function (response) {
                const updatedLecturesList = [
                    ...lecturesList,
                    { id: response.data.lectureId, ...addingLecture }
                ];
                setLecturesList(updatedLecturesList);
                viewContext.notification.show(response.data.message, 'success');
                // Reload when adding an existing lecture.
                if (addingLecture?.id) {
                    window.location.reload();
                }
            })
            .catch((err) => {
                let status = err.response.status;
                if (status === 401) {
                    authContext.signout()
                }
                viewContext.notification.show(err.response.data.message, 'error');
            });
        setNewLecture({})
        discardCloseLecture()
    }

    const [contentEditDetails, setContentEditDetails] = useState({
        type: "",
        lectureID: "",
        action: "",
        lectureIndex: -1,
        source: "",
        transcript: []
    })

    const getLectureSource = async (lectureID) => {
        const options = {
            method: 'GET',
            url: `/api/lms/lectures/${lectureID}/content`,
            headers: {
                "accept": "application/json",
            }
        };

        return new Promise((resolve, reject) => {
            axios
                .request(options)
                .then(function (response) {
                    resolve(response.data.content);
                })
                .catch((err) => {
                    let status = err.response.status;
                    if (status === 401) {
                        authContext.signout();
                    }
                    viewContext.notification.show(err.response.data.message, 'error');
                    reject(err);
                });
        });
    };

    const handleQuizUpload = (quizQuestions, method) => {
        const options = {
            method: method,
            url: "/api/lms/upload/quizzes",
            headers: {
                "accept": "application/json",
            },
            data: { content: quizQuestions, lectureID: contentEditDetails.lectureID },
        };
        axios
            .request(options)
            .then(function (response) {
                if (response.status === 201) {
                    const updatedLecturesList = [...lecturesList];
                    updatedLecturesList[contentEditDetails.lectureIndex].source = true;
                    setLecturesList(updatedLecturesList);
                    setContentEditDetails({
                        type: "",
                        lectureID: "",
                        action: "",
                        lectureIndex: -1,
                        source: "",
                        transcript: []
                    })
                    viewContext.notification.show("Quiz posted successfully.", 'success')
                } else {
                    console.log(response)
                }
            })
            .catch((err) => {
                let status = err.response.status;
                if (status === 401) {
                    authContext.signout()
                }
                viewContext.notification.show(err.response.data.message, 'error');
            });
    }

    const handleUMUpload = (UMSteps, method) => {
        const options = {
            method: method,
            url: "/api/lms/upload/um",
            headers: {
                "accept": "application/json",
                "content-type": 'multipart/form-data'
            },
            data: { content: UMSteps, lectureID: contentEditDetails.lectureID },
        };
        axios
            .request(options)
            .then(function (response) {
                if (response.status === 201) {
                    const updatedLecturesList = [...lecturesList];
                    updatedLecturesList[contentEditDetails.lectureIndex].source = true;
                    setLecturesList(updatedLecturesList);
                    setContentEditDetails({
                        type: "",
                        lectureID: "",
                        action: "",
                        lectureIndex: -1,
                        source: "",
                        transcript: []
                    })
                    viewContext.notification.show("User manual steps posted successfully.", 'success', true)
                } else {
                    console.log(response)
                }
            })
            .catch((err) => {
                let status = err.response.status;
                if (status === 401) {
                    authContext.signout()
                }
                viewContext.notification.show(err.response.data.message, 'error', true);
            });
    }

    const LectureContentJSX = () => {
        const [uploadDone, setUploadDone] = useState(false);
        const [showTranscript, setShowTranscript] = useState(false)
        const ContentEditor = () => {
            switch (contentEditDetails.type) {
                case 'youtube_url':
                    return (
                        <Card
                            title='Add Youtube URL'
                            restrictHeight
                        >
                            {contentEditDetails?.source && <div style={{ display: 'flex', color: 'black', marginBottom: "1em" }}>

                                <Link to={contentEditDetails?.source} target="_blank">
                                    <button className={Styles.viewButton}>
                                        View
                                    </button>
                                </Link>
                            </div>}
                            {!uploadDone ? <Form
                                buttonText='Upload URL'
                                url={`/api/lms/content/youtube/${contentEditDetails.lectureID}`}
                                method={"PATCH"}
                                    
                                inputs={{    

                                    youtube_url: {
                                        label: 'Enter Url',
                                        urlType:'youtube',
                                        type: 'url',
                                        value:contentEditDetails?.source,
                                        required: true,
                                        placeholder: 'https://youtu.be/',
                                        errorMessage: 'Please enter Url to proceed',
                                       }
                                }}
                                callback={(res) => {
                                    setUploadDone(true);
                                    const updatedLecturesList = [...lecturesList];
                                    updatedLecturesList[contentEditDetails.lectureIndex].source = res.data.contentUrl
                                    setLecturesList(updatedLecturesList);
                                    setContentEditDetails({
                                        type: "",
                                        lectureID: "",
                                        action: "",
                                        lectureIndex: -1,
                                        source: ""
                                    })
                                    viewContext.notification.show(res.message, 'success');
                                }}
                            /> :
                                <Message
                                    title='URL Saved'
                                    type='success'
                                    text='The lecture video link has been saved successfully.'
                                />}
                            <AivagamButton
                                id='cancelButton'
                                buttonText={"Close"}
                                onClick={() => {
                                    setContentEditDetails({
                                        type: "",
                                        lectureID: "",
                                        action: "",
                                        lectureIndex: -1,
                                        source: ""
                                    })
                                }}
                                classStyles={{ width: "100%", marginTop: "0.5em" }}
                                type="cancel"
                            />
                        </Card>
                    )
                case 'video':
                    return (
                        <Card
                            title='Upload Video'
                            restrictHeight
                        >
                            {!uploadDone ? <Form
                                buttonText='Upload Video'
                                url={`/api/lms/content/${contentEditDetails.lectureID}`}
                                method={lecturesList[contentEditDetails?.lectureIndex]?.source ? "PATCH" : "POST"}
                                inputs={{
                                    lecture_video: {
                                        label: "Max File Size: 700MB",
                                        type: 'file',
                                        max: 1,
                                        required: true,
                                        maxFileSize: 786432,
                                        accept: ['mp4', 'mkv'],
                                        imageFullUrl: contentEditDetails?.source,
                                    }
                                }}
                                callback={(res) => {
                                    setUploadDone(true);
                                    const updatedLecturesList = [...lecturesList];
                                    /* For content to be visible, source must be true. Here contentUrl is non-empty string which resolves to true */
                                    updatedLecturesList[contentEditDetails.lectureIndex].source = res.data.contentUrl?.contentUrl
                                    setLecturesList(updatedLecturesList);
                                    setContentEditDetails({
                                        type: "",
                                        lectureID: "",
                                        action: "",
                                        lectureIndex: -1,
                                        source: ""
                                    })
                                    viewContext.notification.show(res.message, 'success');
                                }}
                            /> :
                                <Message
                                    title='Video Saved'
                                    type='success'
                                    text='The lecture video has been saved successfully.'
                                />}
                            <AivagamButton
                                id='cancelButton'
                                buttonText={"Close"}
                                onClick={() => {
                                    setContentEditDetails({
                                        type: "",
                                        lectureID: "",
                                        action: "",
                                        lectureIndex: -1,
                                        source: ""
                                    })
                                }}
                                classStyles={{ width: "100%", marginTop: "0.5em" }}
                                type="cancel"
                            />
                        </Card>
                    )
                case 'video_ai_transcript':
                    return (
                        <Card
                            title='Upload Video'
                            restrictHeight
                        >
                            {!uploadDone ?
                                <>
                                    <span style={{ color: 'black', fontSize: '0.75em', display: 'flex', alignItems: 'center', gap: '0.2em', marginBottom: '1em' }}>
                                        Transcript will be automatically generated using AI
                                        <>
                                            <svg width={0} height={0}>
                                                <linearGradient id="linearColors" x1={0} y1={0} x2={1} y2={1}>
                                                    <stop offset={0} stopColor="#FF00FF" />
                                                    <stop offset={1} stopColor="darkblue" />
                                                </linearGradient>
                                            </svg>
                                            <AutoAwesomeIcon sx={{ fill: "url(#linearColors)" }} />
                                        </>
                                    </span>
                                    <span>
                                        <Form
                                            buttonText='Upload Video'
                                            url={`/api/lms/content/${contentEditDetails.lectureID}`}
                                            method={lecturesList[contentEditDetails?.lectureIndex]?.source ? "PATCH" : "POST"}
                                            inputs={{
                                                lecture_video: {
                                                    label: "Max File Size: 700MB",
                                                    type: 'file',
                                                    max: 1,
                                                    required: true,
                                                    maxFileSize: 786432,
                                                    accept: ['mp4', 'mkv'],
                                                    imageFullUrl: contentEditDetails?.source,
                                                },
                                                transcript_enabled: {
                                                    label: "Transcript Enabled",
                                                    type: 'switch',
                                                    default: true,
                                                }
                                            }}
                                            callback={(res) => {
                                                setUploadDone(true);
                                                const updatedLecturesList = [...lecturesList];
                                                updatedLecturesList[contentEditDetails.lectureIndex].source = res.data?.contentUrl?.contentUrl
                                                setLecturesList(updatedLecturesList);
                                                setContentEditDetails({
                                                    type: "",
                                                    lectureID: "",
                                                    action: "",
                                                    lectureIndex: -1,
                                                    source: "",
                                                    transcript: []
                                                })
                                                viewContext.notification.show(res.message, 'success');
                                            }}
                                        />
                                    </span>
                                </> :
                                <Message
                                    title='Video Saved'
                                    type='success'
                                    text='The lecture video has been saved successfully and the transcript has been successfully generated.'
                                />}
                            {showTranscript && (
                                <>
                                    <Backdrop
                                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                                        open
                                    >
                                        <ClickAwayListener onClickAway={() => { setShowTranscript(false) }}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignContent: 'center',
                                                    backgroundColor: 'white',
                                                    fontSize: '0.75em',
                                                    width: '70vw',
                                                    borderRadius: '8px',
                                                    color: "#000"
                                                }}>
                                                <div style={{ width: '100%', margin: '0.2em' }}>
                                                    <Transcript transcriptData={contentEditDetails?.transcript} isInteractive={false} />
                                                </div>
                                            </div>
                                        </ClickAwayListener >
                                    </Backdrop>
                                </>
                            )}
                            <AivagamButton
                                id='showTranscriptButton'
                                buttonText={"Show Transcript"}
                                disabled={uploadDone || !lecturesList[contentEditDetails?.lectureIndex]?.source || contentEditDetails?.transcript?.length === 0}
                                onClick={() => {
                                    setShowTranscript(true)
                                }}
                                classStyles={{ width: "100%", marginTop: "0.5em" }}
                                type="action"
                            />
                            <AivagamButton
                                id='cancelButton'
                                buttonText={"Close"}
                                onClick={() => {
                                    setContentEditDetails({
                                        type: "",
                                        lectureID: "",
                                        action: "",
                                        lectureIndex: -1,
                                        source: ""
                                    })
                                }}
                                classStyles={{ width: "100%", marginTop: "0.5em" }}
                                type="cancel"
                            />
                        </Card>
                    )
                case 'document':
                    return (
                        <Card
                            title='Upload Document'
                        >
                            {!uploadDone ? <Form
                                buttonText='Upload Document'
                                url={`/api/lms/content/${contentEditDetails.lectureID}`}
                                method={lecturesList[contentEditDetails?.lectureIndex]?.source ? "PATCH" : "POST"}
                                inputs={{
                                    lecture_doc: {
                                        label: "Max .pdf File Size: 100MB",
                                        type: 'file',
                                        max: 1, 
                                        required: true,
                                        maxFileSize: 100000,
                                        accept: ['pdf'],
                                        imageFullUrl: contentEditDetails?.source
                                    }
                                }}
                                callback={(res) => {
                                    setUploadDone(true);
                                    const updatedLecturesList = [...lecturesList];
                                    updatedLecturesList[contentEditDetails.lectureIndex].source = res.data.contentUrl?.contentUrl
                                    setLecturesList(updatedLecturesList);
                                    setContentEditDetails({
                                        type: "",
                                        lectureID: "",
                                        action: "",
                                        lectureIndex: -1,
                                        source: ""
                                    })
                                    viewContext.notification.show(res.message, 'success');
                                }}
                            /> :
                                <Message
                                    title='Document Saved'
                                    type='success'
                                    text='The lecture document has been saved successfully.'
                                />}
                            <AivagamButton
                                id='cancelButton'
                                buttonText={"Close"}
                                onClick={() => {
                                    setContentEditDetails({
                                        type: "",
                                        lectureID: "",
                                        action: "",
                                        lectureIndex: -1,
                                        source: ""
                                    })
                                }}
                                classStyles={{ width: "100%", marginTop: "0.5em" }}
                                type="cancel"
                            />
                        </Card>
                    )
                case 'ai_quiz':
                    return (
                        <Card
                            title='Upload Document To Generate Quiz'
                        >
                            {!uploadDone && <Form
                                buttonText='Upload Document'
                                url={`/api/lms/content/ai/${contentEditDetails.lectureID}?numOfQuestions=10`}
                                method='POST'
                                inputs={{
                                    lecture_doc: {
                                        label: 'Max .txt File Size: 65KB | Your file will not be saved.',
                                        type: 'file',
                                        max: 1,
                                        required: true,
                                        maxFileSize: 65,
                                        accept: ['plain'],
                                    }
                                }}
                                callback={(res) => {
                                    if (res.status !== 201) {
                                        viewContext.notification.show(res.response.data.message, 'error');
                                        setTimeout(() => {
                                            setQuizLoading(false);
                                            window.location.reload()
                                        }, 5000)
                                    }
                                    setUploadDone(true);
                                    setQuizLoading(true);
                                    setContentEditDetails({
                                        type: "",
                                        lectureID: "",
                                        action: "",
                                        lectureIndex: -1,
                                        source: ""
                                    });
                                    setTimeout(() => {
                                        setQuizLoading(false);
                                        window.location.reload()
                                    }, 5000)

                                }}
                            />}

                            <AivagamButton
                                id='cancelButton'
                                buttonText={"Close"}
                                onClick={() => {
                                    setContentEditDetails({
                                        type: "",
                                        lectureID: "",
                                        action: "",
                                        lectureIndex: -1,
                                        source: ""
                                    })
                                }}
                                classStyles={{ width: "100%", marginTop: "0.5em" }}
                                type="cancel"
                            />
                        </Card>
                    )
                case 'user_manual':
                    return (
                        <UserManualForm
                            contentEditDetails={contentEditDetails}
                            handleUMUpload={handleUMUpload}
                            setContentEditDetails={setContentEditDetails}
                        />
                    )
                case 'quiz':
                    return (
                        <QuizForm
                            contentEditDetails={contentEditDetails}
                            handleQuizUpload={handleQuizUpload}
                            setContentEditDetails={setContentEditDetails}
                        />
                    )
                default:
                    return (<p style={{ color: "white", backgroundColor: "black" }}>Invalid Lecture Type Chosen</p>)
            }
        }

        return (
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open
            >
                <span className={Styles.lectureContent}>
                    <ContentEditor />
                </span>
            </Backdrop>
        )
    }

    const navigate = useNavigate();

    const getExistingLectures = () => {
        axios.get(`/api/lms/lectures/existing?module_id=${moduleId}`)
            .then((res) => {
                setExistingLecture(res.data.data);
                alterLectureAction({ action: 'add', lectureType: 'existing_lecture' })
            })
            .catch((err) => {
                console.log(err)
            })
    }

    const handleLectureAssociation = async () => {
        handleLectureDelete({ isAssociation: true })
    }

    return (
        <div id='ancestorContainer' className={Styles.ancestorContainer}>
            <LoadingBackdrop isOpen={quizLoading || loading} />
            {confirmSubmit &&
                <ConfirmationCard
                    title={'Delete lecture?'}
                    body={showOptions ? "Where would you like to delete this lecture from?" : "Deleting this lecture will remove it from the module. Are you sure you want to continue?"}
                    showCard={confirmSubmit}
                    setShowCard={setConfirmSubmit}
                    handleConfirm={handleLectureDelete}
                    destructive={true}
                    lectureCard={true}
                    showOptions={showOptions}
                    handleLectureAssociation={handleLectureAssociation}
                />
            }
            {contentEditDetails.type && <LectureContentJSX />}
            <button
                id="backToCoursePage"
                className={Styles.backButton}
                onClick={() => { navigate(`/lms/course/${courseID}/edit`) }}
            >
                <ArrowBackIcon fontSize="small" sx={{ mr: '0.01em' }} /> Back to Course
            </button>
            <div id='moduleTitleContainer' className={Styles.moduleTitleContainer}>
                <p className={Styles.moduleTitle}>
                    {data?.name ? data?.name + ": " : ""} Lectures
                </p>
                <AivagamButton
                    buttonText={
                        <>
                            <FeatherIcon
                                color='black'
                                icon='plus'
                            />
                            Add Lecture
                        </>
                    }
                    onClick={() => {
                        setNewLecture({})
                        alterLectureAction({ visibility: true })
                    }}
                    icon
                    type="edit"
                />
            </div>
            <div id='sectionsContainer' className={Styles.sectionsContainer}>
                {lecturesList?.map((section, sectionIndex) => {
                    if (sectionIndex === showAddLecture.index && showAddLecture.action === 'edit') {
                        return (
                            <div
                                key={`section-${sectionIndex}-${data.name}`}
                                id='sectionHolder'
                                className={Styles.sectionHolder}
                            >
                                <div id='lectureInfo' className={Styles.lectureInfo}>
                                    <p className={Styles.sectionTitle}>
                                        Edit Lecture
                                    </p>
                                    <div id='inputContainer' className={Styles.inputContainer}>
                                        <span>
                                            <TextField
                                                id={`module-name`}
                                                name="name"
                                                size="small"
                                                required
                                                placeholder="Name the Lecture a Suitable Title"
                                                inputProps={{
                                                    maxLength: 32
                                                }}
                                                value={newLecture.name || ""}
                                                onChange={(e) => {
                                                    const { name, value } = e.target;
                                                    handleLectureChange(name, value)
                                                }}
                                            />
                                            <TextField
                                                id={`lecture-type`}
                                                name="type"
                                                select
                                                required
                                                size="small"
                                                error={newLecture.lockSelect}
                                                disabled={newLecture.lockSelect}
                                                SelectProps={{
                                                    MenuProps: { disableScrollLock: true }
                                                }}
                                                value={newLecture.type || ""}
                                                onChange={(e) => {
                                                    const { name, value } = e.target;
                                                    handleLectureChange(name, value)
                                                }}
                                                helperText={newLecture.lockSelect ? 'To Change Delete and Create New Lecture' : 'Select Lecture Type'}
                                            >
                                                {data?.validTypes?.map((option) => (
                                                    <MenuItem
                                                        key={option.value}
                                                        value={option.value}
                                                        disabled={option.addOn || newLecture.lockSelect}
                                                        sx={(option.addOn || newLecture.lockSelect) ? { fontStyle: 'italic', display: 'flex', gap: '0.4em' } : {}}
                                                    >
                                                        {option.addOn &&
                                                            <FeatherIcon
                                                                // color='yellow'
                                                                icon={'star'}
                                                            />
                                                        }
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </span>
                                        <span>
                                            <TextField
                                                id={`lecture-description`}
                                                name="description"
                                                multiline={true}
                                                required
                                                size="small"
                                                fullWidth
                                                placeholder={`Describe the content of this lecture in a few lines.`}
                                                rows={4}
                                                value={newLecture.description || ""}
                                                onChange={(e) => {
                                                    const { name, value } = e.target;
                                                    handleLectureChange(name, value)
                                                }}
                                            />
                                        </span>
                                    </div>
                                </div>
                                <div id='actionsContainer' className={Styles.actionsContainer}>
                                    <Tooltip arrow title="Close">
                                        <span>
                                            <button onClick={discardCloseLecture}>
                                                <FeatherIcon
                                                    color='black'
                                                    icon='x'
                                                    role="button"

                                                />
                                            </button>
                                        </span>
                                    </Tooltip>
                                    <Tooltip arrow title="Done">
                                        <span>
                                            <button
                                                disabled={!newLecture.name || !newLecture.description || !newLecture.type}
                                                onClick={() => { handleLectureUpdate(sectionIndex) }}
                                            >
                                                <FeatherIcon
                                                    color='black'
                                                    icon='check'
                                                />
                                            </button>
                                        </span>
                                    </Tooltip>
                                </div>
                            </div>
                        )
                    } else {
                        return (
                            <div
                                key={`section-${sectionIndex}-${data?.name}`}
                                id='sectionHolder'
                                className={Styles.sectionHolder}
                                style={{
                                    border: !!!section?.source ? '2px solid red' : ''
                                }}
                            >
                                <div id='lectureInfo' className={Styles.lectureInfo}>
                                    <p className={Styles.sectionTitle}>
                                        <GetIcon
                                            type={section.type}
                                        />
                                        {section.name}
                                        {!!!section.source &&
                                            <span className={Styles.blinkText}>
                                                • Content Missing
                                            </span>
                                        }
                                        {section?.ai &&
                                            <span className={Styles.blinkAIText}>
                                                • AI Generated
                                            </span>
                                        }
                                    </p>
                                    <p className={Styles.sectionDescr}>
                                        {section.description}
                                    </p>
                                </div>
                                <div id='actionsContainer' className={Styles.actionsContainer}>
                                    <Tooltip arrow title="Delete">
                                        <span>
                                            <FeatherIcon
                                                color='black'
                                                icon='trash'
                                                role="button"
                                                onClick={() => {
                                                    alterLectureAction({ action: "delete", editIndex: sectionIndex, lectureID: section.id })
                                                }}
                                            />
                                        </span>
                                    </Tooltip>
                                    <Tooltip arrow title="Edit">
                                        <span>
                                            <FeatherIcon
                                                color='black'
                                                role="button"
                                                icon='edit-2'
                                                onClick={() => {
                                                    syncLectureEdit(sectionIndex)
                                                    alterLectureAction({ visibility: false, action: "edit", editIndex: sectionIndex, lectureID: section.id })
                                                }}
                                            />
                                        </span>
                                    </Tooltip>
                                    {!!!section.source &&
                                        <Tooltip arrow open title="Add Content">
                                            <span className={Styles.blinkText}>
                                                <FeatherIcon
                                                    role="button"
                                                    color='red'
                                                    icon='alert-octagon'
                                                    onClick={() => {
                                                        setContentEditDetails({
                                                            type: section.type,
                                                            lectureID: section.id,
                                                            lectureIndex: sectionIndex,
                                                            action: "add"
                                                        })
                                                    }}
                                                />
                                            </span>
                                        </Tooltip>
                                    }
                                    {!!section.source &&
                                        <Tooltip arrow title="View Content">
                                            <span>
                                                <FeatherIcon
                                                    color='black'
                                                    role="button"
                                                    icon='eye'
                                                    onClick={async () => {
                                                        /* This is where the content is being set when we click on view. Separate API call goes in getLectureSource and sets the content */
                                                        const lectureSource = await getLectureSource(section.id)
                                                        if (lectureSource) {
                                                            setContentEditDetails({
                                                                type: section.type,
                                                                lectureID: section.id,
                                                                lectureIndex: sectionIndex,
                                                                action: "edit",
                                                                source: ['video', 'video_ai_transcript', 'document'].includes(section.type) ? lectureSource.completeUrl : lectureSource,
                                                                transcript: lectureSource.transcript
                                                            })
                                                        }
                                                    }}
                                                />
                                            </span>
                                        </Tooltip>
                                    }
                                </div>
                            </div>)
                    }
                })}
                {(showAddLecture.action === 'add' && showAddLecture.lecture_type === 'new_lecture') &&
                    <div
                        id='sectionHolder'
                        className={Styles.sectionHolder}
                    >
                        <div id='lectureInfo' className={Styles.lectureInfo}>
                            <p className={Styles.sectionTitle}>
                                Edit Lecture
                            </p>
                            <div id='inputContainer' className={Styles.inputContainer}>
                                <span>
                                    <TextField
                                        id={`module-name`}
                                        label="Title"
                                        name="name"
                                        size="small"
                                        required
                                        placeholder="Name the Lecture a Suitable Title"
                                        inputProps={{
                                            maxLength: 32
                                        }}
                                        value={newLecture?.name || ""}
                                        onChange={(e) => {
                                            const { name, value } = e.target;
                                            handleLectureChange(name, value)
                                        }}
                                    />
                                    <TextField
                                        id={`lecture-type`}
                                        label="Type"
                                        name="type"
                                        select
                                        required
                                        size="small"
                                        // error={newLecture.lockSelect}
                                        // disabled={newLecture.lockSelect}
                                        SelectProps={{
                                            MenuProps: { disableScrollLock: true }
                                        }}
                                        value={newLecture?.type || ""}
                                        onChange={(e) => {
                                            const { name, value } = e.target;
                                            handleLectureChange(name, value)
                                        }}
                                        helperText={'Select Lecture Type'}
                                    >
                                        {data?.validTypes?.map((option) => (
                                            <MenuItem
                                                key={option.value}
                                                value={option.value}
                                                disabled={option.addOn}
                                                sx={(option.addOn) ? { fontStyle: 'italic', display: 'flex', gap: '0.4em' } : {}}
                                            >
                                                {option.addOn &&
                                                    <FeatherIcon
                                                        // color='yellow'
                                                        icon={'star'}
                                                    />
                                                }
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </span>
                                <span>
                                    <TextField
                                        id={`lecture-description`}
                                        name="description"
                                        multiline={true}
                                        label="Description"
                                        required
                                        size="small"
                                        fullWidth
                                        placeholder={`Describe the content of this lecture in a few lines.`}
                                        rows={4}
                                        value={newLecture?.description || ""}
                                        onChange={(e) => {
                                            const { name, value } = e.target;
                                            handleLectureChange(name, value)
                                        }}
                                    />
                                </span>
                            </div>
                        </div>
                        <div id='actionsContainer' className={Styles.actionsContainer}>
                            <Tooltip arrow title="Discard">
                                <span>
                                    <button
                                        onClick={discardCloseLecture}
                                    >
                                        <FeatherIcon
                                            color='black'
                                            icon='x'
                                            role="button"

                                        />
                                    </button>
                                </span>
                            </Tooltip>
                            <Tooltip
                                arrow
                                title={!newLecture.name || !newLecture.description || !newLecture.type ? "Please fill Title, Description, and Lecture Type" : "Save"}
                                open={!newLecture.name || !newLecture.description || !newLecture.type}
                            >
                                <span>
                                    <button
                                        disabled={!newLecture.name || !newLecture.description || !newLecture.type}
                                        onClick={handleLecturePost}
                                    >
                                        <FeatherIcon
                                            color='black'
                                            icon='check'
                                        />
                                    </button>
                                </span>
                            </Tooltip>
                        </div>
                    </div>
                }
            </div>
            {showAddLecture?.show && <LectureTypeJSX
                open={showAddLecture.show}
                alterLectureAction={alterLectureAction}
                showAddLecture={showAddLecture}
                selectExistingLecture={selectExistingLecture}
                handleLecturePost={handleLecturePost}
                discardCloseLecture={discardCloseLecture}
                newLecture={newLecture}
                getExistingLectures={getExistingLectures}
                existingLecture={existingLecture}

            />}
        </div>
    );
}
